import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-why-we-stand-out',
  templateUrl: './why-we-stand-out.component.html',
  styleUrls: ['./why-we-stand-out.component.scss']
})
export class WhyWeStandOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
